<template>
  <form>
    <div class="row">
      <div class="col-lg-6">
        <div class="mt-4">
          <h5 class="font-weight-bold">
            Evaluate revised version
          </h5>
          <div class="row">
            <div class="col-sm-7">
              <div class="form-group">
                <label for="revision_status">Approved Status:</label>
                <select class="form-control"
                  v-model="EvaluationForm.model.revision_status"
                  name="revision_status"
                  :disabled="!EvaluationForm.isEditable"
                >
                  <option :value="status" v-for="status in ['APPROVED', 'REJECTED']" :key="status">{{status}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';
  import {Select, Option} from 'element-ui';

  export default {
    components: {
      InfoRight,
      ApplicationInfo,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
